module.exports = __webpack_public_path__ + "static/media/bg_vector_1.66bcbc64.png";